@if (showStatusBox) {
  <div class='status-message-container'>
    <mat-card appearance="outlined" class="status-message-banner">
      <div class="status-text">
        <span class="material-symbols-outlined">info</span> {{statusText}}
      </div>
    </mat-card>
  </div>
}

<div class="card-container">

  <!-- TEMPLATE (download )-->
  @if (displayCardOne) {
    <mat-card appearance="outlined" class="card-item">
      <mat-card-header>
        <span class="heading-container">
          <button mat-mini-fab disabled class="mini-fab-button">1</button>
          <mat-card-title>{{cardOneLabel}}</mat-card-title>
        </span>
      </mat-card-header>
      <mat-card-content>{{cardOneSubtitle}}</mat-card-content>
      <mat-card-footer>
        <div class="flex-bottom">
          <button type="submit" mat-raised-button color="primary"
          (click)="downloadBrokerTemplate()">{{cardOneButtonLabel}}</button>
        </div>
      </mat-card-footer>
    </mat-card>
  }

  <!-- TEMPLATE ( fill )-->
  @if (displayCardTwo) {
    <mat-card appearance="outlined" class="card-item">
      <mat-card-header>
        <span class="heading-container">
          <button mat-mini-fab disabled class="mini-fab-button">2</button>
          <mat-card-title>{{cardTwoLabel}}</mat-card-title>
        </span>
      </mat-card-header>
      <mat-card-content>{{cardTwoSubtitle}}</mat-card-content>
    </mat-card>
  }

  <!-- TEMPLATE ( upload ) -->
  @if (displayCardThree) {
    <mat-card appearance="outlined" class="card-item">
      <mat-card-header>
        <span class="heading-container">
          <button mat-mini-fab disabled class="mini-fab-button">3</button>
          <mat-card-title>{{cardThreeLabel}}</mat-card-title>
        </span>
      </mat-card-header>
      <mat-card-content>{{cardThreeSubtitle}}</mat-card-content>
      <mat-card-footer>
        <div class="flex-bottom">
          @if (!showSpinner) {
            <label for="file" class="input-as-button-label">{{cardThreeButtonLabel}}</label>
            <input type="file" accept=".csv, .xlsx, .xls" id="file" (change)="handleFileInput($event.target.files)">
          }
          @if (showSpinner) {
            <mat-spinner [diameter]="40"></mat-spinner>
          }
        </div>
      </mat-card-footer>
    </mat-card>
  }
</div>

<div class="file-display-table-container">
  <mat-table mat-table class="mat-elevation-z8" matSort matSortActive="dateTime" matSortDirection="desc"
    [dataSource]="dataSource">

    <ng-container matColumnDef="filename">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <span class="label-and-form-field-container">
          <span class="header-span">File Name</span>
          <mat-form-field class="filter">
            <mat-label>Search</mat-label>
            <input matInput [formControl]="fileNameFilter" (keydown.space)="$event.stopPropagation()" (click)="$event.stopPropagation()">
          </mat-form-field>
        </span>
      </mat-header-cell>
      <mat-cell *matCellDef="let file">{{file.filename}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="dateTime">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <span class="label-and-form-field-container">
          <span class="header-span">Upload Date</span>
          <mat-form-field class="filter">
            <mat-label>Search</mat-label>
            <input matInput [formControl]="dateFilter" (keydown.space)="$event.stopPropagation()" (click)="$event.stopPropagation()">
          </mat-form-field>
        </span>
      </mat-header-cell>
      <mat-cell *matCellDef="let file">{{file.dateTime}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="message">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <span class="label-and-form-field-container">
          <span class="header-span">File Upload Status</span>
          <mat-form-field class="filter">
            <mat-label>Search</mat-label>
            <input matInput [formControl]="statusFilter" (keydown.space)="$event.stopPropagation()" (click)="$event.stopPropagation()">
          </mat-form-field>
        </span>
      </mat-header-cell>
      <mat-cell *matCellDef="let file" class="file-status-container">
        @if (uploadSuccess(file.message)) {
          <span class="material-symbols-outlined">check_circle_outline</span>
        }
        @if (!uploadSuccess(file.message)) {
          <span class="material-symbols-outlined">warning</span>
        }
        {{file.message}}
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

  </mat-table>
  <div class="paginator-container">
    <mat-paginator #paginator [pageSizeOptions]="[10, 25, 100]">
    </mat-paginator>
  </div>
</div>
